import React from "react"
import Button from "./Button"

interface BackButtonProps {
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const goBack = () => { history.back() }

const BackButton: React.FC<BackButtonProps> = ({ className, disabled, onClick }: BackButtonProps) => {
  return (
    <Button
      className={className}
      disabled={disabled}
      i18key="controls.buttons.back"
      id="btn_back"
      leftSymbolId="arrow-left"
      light
      onClick={onClick || goBack}
    />
  )
}

export default BackButton
